export const categories = {
  promotional: 'Promotional',
  normal: 'Normal',
}
